import React from 'react';
import classNames from "classnames";
import { createStyles, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => createStyles({
  wrap: {
    padding: '16px 0',
    [theme.breakpoints.down(600)]: {
      padding: 0
    },
    fontSize: '38px',
    fontWeight: 500,
    lineHeight: '56px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  title: {
    margin: 0,
  },
}));

interface Props {
  text?: string;
  padding?: any;
  spaceBetween?: boolean;
}

const TitleComp: React.FC<Props> = ({
  padding, text, spaceBetween, children,
}) => {
  const classes = useStyles();
  
  const styles = {
    padding,
  };

  return (
    <div
      style={styles}
      className={classNames(classes.wrap, { [classes.spaceBetween]: spaceBetween })}
    >
      <Typography className={classes.title} variant="h6">
          {text}
        </Typography>
      {children}
    </div>
  );
};

export default TitleComp;
